/**
 * Styled Components - Created by miguelcanobbio on 14/08/18.
 */
import styled from 'styled-components'

export const Container = styled.div`
  width: 208px;
  margin: 0 auto;
  cursor: pointer;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  font-family: Avenir;
`

export const Image = styled.img`
  width: 208px;
  height: 208px;
  background-color: #f1f4f5;
  object-fit: cover;
`

export const Title = styled.div`
  width: 221px;
  color: #5f6062;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.11px;
  line-height: 22px;
  text-align: center;
  margin-top: 4px;
`

export const Description = styled.div`
  text-align: center;
  font-size: 13px;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterRelated/InspirationItem/styledComponents.tsx